import Button from "components/atoms/button/Button";
import Icon from "components/atoms/icon/Icon";
import { useTranslation } from "react-i18next";
import { IconType } from "../iconTypes";

export const HrPendingHeaders = (
    { setModalData }: {
        setModalData?: (data: { modalType: string; data: any }) => void
    }) => {

    const { t } = useTranslation();

    return [
        {
            id: 1,
            Header: t("Created At"),
            accessor: (row: any) => new Date(row?.created_at),
            Cell: ({ row: { original } }: any) => {
                return (
                    <p
                        className="text-[14px] font-inter-medium text-[#282D46] cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "hr", data: original })}
                    >
                        {new Date(original.created_at).toLocaleDateString('de')}
                    </p>
                );
            },
            isChecked: true,
        },
        {
            id: 2,
            Header: t("Pending Title"),
            accessor: "title",
            Cell: ({ row: { original } }: any) => {
                return (
                    <div
                        className="flex gap-1 items-center cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "hr", data: original })}
                    >

                        <p className="text-[14px] font-inter-medium text-[#282D46]">
                            {original?.pending_name}
                        </p>
                    </div>
                );
            },
            isChecked: true,
        },
        {
            id: 3,

            Header: t("Consultant"),
            accessor: "user_id",
            Cell: ({ row: { original } }: any) => {
                return (
                    <div
                        className="flex gap-1 items-center cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "hr", data: original })}
                    >
                        <h1 className="text-[14px] font-inter-medium text-[#282D46]">
                            {original?.user.name + " " + original?.user.last_name}
                        </h1>
                    </div>
                );
            },
            isChecked: true,
        },
        {
            id: 4,

            Header: t("Status"),
            accessor: "status",
            Cell: ({ row: { original } }: any) => {
                const status = original?.completed === 1 ? 'Done' : 'Open';
                return (
                    <p
                        onClick={() => setModalData && setModalData({ modalType: "hr", data: original })}
                        className={`min-w-[50px] cursor-pointer w-[max-content] h-[24px] p-3 text-[12px] font-inter-medium flex items-center justify-center rounded-[4px] capitalize 
                            ${status === "Done"
                                ? "bg-[#2DE28B] bg-opacity-[10%] text-[#2DE28B]"
                                : status === "Open"
                                    ? "bg-[#F88532] bg-opacity-[10%] text-[#F88532]"
                                    : ""
                            }`}
                    >
                        {t(status)}
                    </p>
                );
            },
            isChecked: true,
        },
        {
            id: 5,
            Header: t("Completed At"),
            accessor: (row: any) => new Date(row?.completed_at),
            Cell: ({ row: { original } }: any) => {
                return (
                    <p
                        className="text-[14px] font-inter-medium text-[#282D46] cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "hr", data: original })}
                    >
                        {original?.completed_at ? new Date(original?.completed_at).toLocaleDateString('de') ?? t("Not Available") : '-'}
                    </p>
                );
            },
            isChecked: true,
        },
        {
            id: 6,
            Header: "",
            accessor: "actions",
            Cell: ({ row: { original } }: any) => {
                return (
                    <div
                        className="flex items-center gap-[3px] ml-auto justify-end cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "hr", data: original })}
                    >
                        <Button
                            type="button"
                            onClick={() => setModalData && setModalData({ modalType: "hr", data: original })}
                        >
                            <Icon iconType={IconType.SHOW_PASSWORD_ICON} />
                        </Button>
                        {/* <Icon iconType={IconType.DELETE_ICON} color="#7D8592" /> */}
                    </div>
                );
            },
            isChecked: true,
        }
    ];

}
